import EmptyStatesPreview from '../content/EmptyStatesPreview'
import { HiPlus } from 'react-icons/hi'
import { LinkButton } from '@eggplant/pattern-library'
import {
  LinkToAddTestManagementTool,
  useSpaceAccess
} from '@eggplant/routing'
import { LinkToTestManagementToolsDoc } from '../links'
import { SpaceAccessControl } from '@eggplant/context'
import { TestManagementIntegration } from '@eggplant/pattern-library/src/lib/components/Artwork/Artwork'

const baseDescription = 'Integrate your preferred test management tools with DAI to streamline test case syncing and reporting. Connect once to keep your test cases, requirements, and execution results automatically aligned between systems.'

const renderLinkToDoc = () =>
  <LinkToTestManagementToolsDoc />

const TestManagementIntegrationIntro = () => {
  const [isAccessible] = useSpaceAccess()

  const viewerDescription = baseDescription

  const createableDescription = `${baseDescription}

🔗 Add a new test management tool now!`

  const description = isAccessible
    ? createableDescription
    : viewerDescription

  const renderButton = () => isAccessible &&
    <SpaceAccessControl isHiddenIfDenied>
      <LinkButton variant='primary'>
        <LinkToAddTestManagementTool>
          <HiPlus
            aria-hidden
            size='19.2px'
          />
          New test management tool
        </LinkToAddTestManagementTool>
      </LinkButton>
    </SpaceAccessControl>

  return (
    <div className='grid h-full justify-center'>
      <div className='grid w-[36em]'>
        <EmptyStatesPreview
          action={renderButton()}
          description={description}
          icon={<TestManagementIntegration />}
          renderLink={renderLinkToDoc()}
          title='Test management tools'
        />
      </div>
    </div>
  )
}

export default TestManagementIntegrationIntro
